import { render, staticRenderFns } from "./Waitwhile.vue?vue&type=template&id=e22225ba"
import script from "./Waitwhile.vue?vue&type=script&lang=js"
export * from "./Waitwhile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports